import React from 'react';
import { ShieldCheck, QrCode } from 'lucide-react';

export default function CardValidacaoDigital({ comprovanteAtivo = true }) {
    return (
        <>
            <div className="vc-shead">
                <div className="vc-shead__left">
                    <span className="vc-shead__num">02</span>
                    <div>
                        <div className="vc-shead__eyebrow">Autenticidade</div>
                        <h2 className="vc-shead__title">Documento verificável</h2>
                    </div>
                </div>
                <p className="vc-shead__desc">
                    Emitido com assinatura digital, com validade em todo o território nacional.
                </p>
            </div>

            <div className="vc-valid">
                <div>
                    <p className="vc-valid__lead">
                        Sua carteirinha pode ser conferida por qualquer pessoa: basta ler o
                        QR Code impresso no documento para abrir a página oficial de validação da UNAE,
                        onde os seus dados de estudante são confirmados em tempo real.
                        {comprovanteAtivo
                            ? ' Você também pode baixar o comprovante de validação no topo da página.'
                            : ''}
                    </p>
                    <span className="vc-valid__chip">
                        <ShieldCheck size={16} /> Validação oficial UNAE
                    </span>
                </div>

                <div className="vc-valid__qr">
                    <QrCode size={64} strokeWidth={1.5} />
                    <span>Aponte a câmera para o QR Code da carteirinha</span>
                </div>
            </div>
        </>
    );
}
